import type { TrainingActivityProofFile } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<TrainingActivityProofFile>('/training-activity-proof-files/:id');
